import React from 'react';

import { ReactComponent as ArrowIcon } from '../../../icons/arrow-right.svg';

import { TagWrapper } from './components/tag-wrapper/tag-wrapper';
import styles from './default-button.module.scss';

export const DefaultButton: React.FC<{
  label: string;
  light?: boolean;
  onClick?: (parameter?: any) => void;
}> = ({ label, light, onClick }) => {
  return (
    <div className={styles.defaultButton} onClick={onClick}>
      <TagWrapper label={label} light={light}>
        <ArrowIcon />
      </TagWrapper>
    </div>
  );
};
